import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import type { ResetPasswordData } from "../types";

export function useResetPasswordMutation() {
  return useMutation({
    mutationFn: (payload: ResetPasswordData) => authApi.resetPassword(payload),
  });
}
